/**
 * This hook intentionally reads/writes refs during render to track the previous value.
 * This is the intended behavior despite violating react-hooks/refs.
 */
/* eslint-disable react-hooks/refs */
import React from "react";

function usePrevious<T>(value: T): T | undefined {
  const valueRef = React.useRef<T>(undefined);
  const prevValue = valueRef.current;
  valueRef.current = value;
  return prevValue;
}

export default usePrevious;
